module.exports = __webpack_public_path__ + "img/deleted.c90a8d2b.svg";